export enum Role {
    EMPLOYEE = "EMPLOYEE",
    EMPLOYEE_GROUP = "EMPLOYEE_GROUP",
    EMPLOYEE_GROUP_ADMIN = "EMPLOYEE_GROUP_ADMIN",
    USER = "USER"
}
